export default __webpack_public_path__ + "ab441d2.png";